'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ANDROID_APP_URL, IOS_APP_URL, detectDeviceOS } from '@/lib/appLinks';

export default function DownloadPage() {
  const router = useRouter();

  useEffect(() => {
    const os = detectDeviceOS();

    if (os === 'android') {
      window.location.href = ANDROID_APP_URL;
    } else if (os === 'ios') {
      window.location.href = IOS_APP_URL;
    } else {
      router.push('/'); // fallback to your homepage
    }
  }, [router]);

  return (
    <div className="legacy-page" style={{ textAlign: 'center', padding: '3rem' }}>
      <h1>Redirecting to the Just Gold App...</h1>
      <p>If you&apos;re not redirected, <Link href="/">click here</Link>.</p>
    </div>
  );
}
